/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_National_Id_Issued_PlaceInputs */

const vi_grower_national_id_issued_place = /** @type {(inputs: Grower_National_Id_Issued_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nơi cấp CCCD`)
};

/**

* @param {Grower_National_Id_Issued_PlaceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_national_id_issued_place = /** @type {((inputs?: Grower_National_Id_Issued_PlaceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_National_Id_Issued_PlaceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_national_id_issued_place(inputs)
});